"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationContainer = void 0;
const react_1 = __importDefault(require("react"));
const framer_motion_1 = require("framer-motion");
const styles_1 = require("./styles");
const variants = {
    enter: (direction) => ({
        x: direction === -1 ? '-20%' : '20%',
        opacity: 0
    }),
    center: {
        zIndex: 1,
        x: 0,
        opacity: 1
    },
    exit: (direction) => ({
        zIndex: 0,
        x: direction === -1 ? '20%' : '-20%',
        opacity: 0
    })
};
const AnimationContainer = ({ onAnimationComplete, state, direction, children, onAnimationStart }) => {
    return (react_1.default.createElement(framer_motion_1.AnimatePresence, { custom: direction, exitBeforeEnter: true, initial: false },
        react_1.default.createElement(styles_1.LayoutBody, { key: state, custom: direction, variants: variants, initial: "enter", animate: "center", exit: "exit", onAnimationComplete: onAnimationComplete, onAnimationStart: onAnimationStart }, children)));
};
exports.AnimationContainer = AnimationContainer;
//# sourceMappingURL=AnimationContainer.js.map